<div class="d-lg-flex">
    <div class="chat-leftsidebar card" style="position: relative;">
        <div class="p-3 px-4 border-bottom">
            <div class="d-flex align-items-start ">
                <div class="flex-shrink-0 me-3 align-self-center">
                    <div class="avatar-sm bg-primary-subtle rounded-circle d-flex align-items-center justify-content-center">
                        <span class="text-primary fw-bold">{{ getUsuarioInicial() }}</span>
                    </div>
                </div>

                <div class="flex-grow-1">
                    <h5 class="font-size-16 mb-1">
                        <a href="javascript:void(0)" class="text-body">
                            {{ getUsuarioNome() }} 
                            <i [class]="getStatusIconClass(statusAtendente) + ' align-middle ms-1'" style="font-size: 0.75rem;"></i>
                        </a>
                    </h5>
                    <p class="text-muted mb-0">{{ getStatusAtendenteLabel(statusAtendente) }}</p>
                </div>

                <div class="flex-shrink-0">
                    <div class="dropdown chat-noti-dropdown" ngbDropdown>
                        <button 
                            class="btn dropdown-toggle p-0" 
                            type="button" 
                            data-bs-toggle="dropdown" 
                            aria-haspopup="true" 
                            aria-expanded="false" 
                            ngbDropdownToggle
                            [disabled]="isLoadingStatus">
                            @if (isLoadingStatus) {
                                <div class="spinner-border spinner-border-sm text-primary" style="width: 1rem; height: 1rem;">
                                    <span class="visually-hidden">Carregando...</span>
                                </div>
                            } @else {
                                <i class="bx bx-dots-horizontal-rounded"></i>
                            }
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                            <h6 class="dropdown-header">Status do Atendente</h6>
                            <a 
                                class="dropdown-item" 
                                href="javascript:void(0);"
                                [class.active]="statusAtendente === 'online'"
                                (click)="atualizarStatusAtendente('online'); $event.preventDefault()">
                                <i class="mdi mdi-circle text-success me-2" style="font-size: 0.6rem;"></i>Online
                            </a>
                            <a 
                                class="dropdown-item" 
                                href="javascript:void(0);"
                                [class.active]="statusAtendente === 'ausente'"
                                (click)="atualizarStatusAtendente('ausente'); $event.preventDefault()">
                                <i class="mdi mdi-circle text-warning me-2" style="font-size: 0.6rem;"></i>Ausente
                            </a>
                            <a 
                                class="dropdown-item" 
                                href="javascript:void(0);"
                                [class.active]="statusAtendente === 'offline'"
                                (click)="atualizarStatusAtendente('offline'); $event.preventDefault()">
                                <i class="mdi mdi-circle text-secondary me-2" style="font-size: 0.6rem;"></i>Offline
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-3">
           
            <div class="search-box position-relative">
                <input 
                    type="text" 
                    class="form-control rounded border" 
                    placeholder="Pesquisar..."
                    [(ngModel)]="buscaConversa">
                <i class="bx bx-search search-icon"></i>
            </div>
        </div>

        <div class="chat-leftsidebar-nav">
            <ul ngbNav #transactions="ngbNav" [activeId]="1" class="nav nav-pills nav-justified bg-light-subtle p-1">
                <li [ngbNavItem]="1" class="nav-item">
                    <a ngbNavLink href="javascript:void(0)" data-bs-toggle="tab" aria-expanded="true" class="nav-link">
                        <i class="bx bx-chat font-size-20 d-sm-none"></i>
                        <span class="d-none d-sm-block">Conversas</span>
                    </a>
                    <ng-template ngbNavContent>
                        <ngx-simplebar 
                            #chatScrollContainer
                            class="chat-message-list">
                            <div class="px-3">
                                <h5 class="font-size-14 mb-3">Recentes</h5>
                            </div>
                            @if (isLoadingChats && chats.length === 0) {
                                <div class="text-center py-3">
                                    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                                </div>
                            } @else {
                                <ul class="list-unstyled chat-list">
                                    @for (chat of chats; track chat.id) {
                                        <li [ngClass]="{
                                            'active': conversaSelecionada?.id === chat.id, 
                                            'chat-not-owned': !pertenceAoUsuarioLogado(chat),
                                            'chat-transferida': foiTransferida(chat)
                                        }">
                                            <a href="javascript: void(0);" (click)="selecionarChat(chat)" [class.chat-not-owned-link]="!pertenceAoUsuarioLogado(chat)">
                                                <div class="d-flex align-items-start">

                                                    <div class="flex-shrink-0 user-img online align-self-center me-3">
                                                        <div class="avatar-sm align-self-center">
                                                            @if (isChatLoading(chat.id)) {
                                                                <div class="spinner-border spinner-border-sm text-primary" role="status" style="width: 1.5rem; height: 1.5rem;">
                                                                    <span class="visually-hidden">Carregando...</span>
                                                                </div>
                                                            } @else {
                                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                                    {{ chat.name.charAt(0).toUpperCase() }}
                                                                </span>
                                                            }
                                                        </div>
                                                        <span class="user-status" [class.bg-success]="chat.unreadCount === 0" [class.bg-warning]="chat.unreadCount > 0"></span>
                                                    </div>

                                                    <div class="flex-grow-1 overflow-hidden">
                                                        <h5 class="text-truncate font-size-14 mb-1">
                                                            @if (isChatLoading(chat.id)) {
                                                                <span class="text-muted">Carregando...</span>
                                                            } @else {
                                                                {{ chat.name }}
                                                                @if (chat.isGroup) {
                                                                    <i class="mdi mdi-account-group ms-1" style="font-size: 0.75rem;"></i>
                                                                }
                                                                @if (foiTransferida(chat)) {
                                                                    <span class="badge bg-warning text-dark ms-2" title="Conversa transferida">
                                                                        <i class="fas fa-exchange-alt me-1"></i>
                                                                        Transferida
                                                                    </span>
                                                                }
                                                            }
                                                        </h5>
                                                        <p class="text-truncate mb-0">
                                                            @if (isChatLoading(chat.id)) {
                                                                <span class="text-muted small">Buscando informações...</span>
                                                            } @else if (chat.lastMessage) {
                                                                {{ chat.lastMessage.body }}
                                                            }
                                                        </p>
                                                        @if (chat.nomeAtendente) {
                                                            <small class="text-muted d-block mt-1" style="font-size: 0.7rem; opacity: 0.7;">
                                                                <i class="mdi mdi-account-circle me-1" style="font-size: 0.65rem;"></i>
                                                                {{ chat.nomeAtendente }}
                                                            </small>
                                                        }
                                                    </div>
                                                    <div class="flex-shrink-0">
                                                        <div class="d-flex flex-column align-items-end gap-1">
                                                            @if (chat.unreadCount > 0) {
                                                                <span class="badge bg-success rounded-pill">{{ chat.unreadCount }}</span>
                                                            }
                                                            @if (estaForaDaJanela24Horas(chat)) {
                                                                <i class="mdi mdi-lock chat-lock-icon" title="Fora da janela de 24 horas"></i>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    }
                                </ul>
                                @if (isLoadingChats && chats.length > 0) {
                                    <div class="text-center py-3">
                                        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                                        <p class="text-muted small mt-2">Carregando mais chats...</p>
                                    </div>
                                }
                                @if (!chatsHasMore && chats.length > 0) {
                                    <div class="text-center py-2">
                                        <p class="text-muted small">Todos os chats foram carregados</p>
                                    </div>
                                }
                            }
                        </ngx-simplebar>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2" class="nav-item">
                    <a ngbNavLink>Grupos</a>
                    <ng-template ngbNavContent>
                        <ngx-simplebar class="chat-message-list" style="overflow: auto;">

                            <div class="px-3">
                                <h5 class="font-size-14 mb-3">Groups</h5>
                            </div>
                            <ul class="list-unstyled chat-list">
                                <li>
                                    <a href="javascript:void(0)">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 avatar-sm me-3">
                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                    G
                                                </span>
                                            </div>

                                            <div class="flex-grow-1">
                                                <h5 class="font-size-14 mb-0">General</h5>
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a href="javascript:void(0)">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 avatar-sm me-3">
                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                    R
                                                </span>
                                            </div>

                                            <div class="flex-grow-1">
                                                <h5 class="font-size-14 mb-0">Reporting</h5>
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a href="javascript:void(0)">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 avatar-sm me-3">
                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                    M
                                                </span>
                                            </div>

                                            <div class="flex-grow-1">
                                                <h5 class="font-size-14 mb-0">Meeting</h5>
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a href="javascript:void(0)">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 avatar-sm me-3">
                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                    A
                                                </span>
                                            </div>

                                            <div class="flex-grow-1">
                                                <h5 class="font-size-14 mb-0">Project A</h5>
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a href="javascript:void(0)">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 avatar-sm me-3">
                                                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                    B
                                                </span>
                                            </div>

                                            <div class="flex-grow-1">
                                                <h5 class="font-size-14 mb-0">Project B</h5>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>

                        </ngx-simplebar>
                    </ng-template>
                </li>
                <li [ngbNavItem]="3" class="nav-item">
                    <a ngbNavLink>Contatos</a>
                    <ng-template ngbNavContent>
                        <ngx-simplebar class="chat-message-list" style="overflow: auto;">
                            <div class="px-3">
                                <h5 class="font-size-14 mb-3">Contatos</h5>
                            </div>
                            <div>
                                <div>
                                    <div class="px-3 contact-list">A</div>

                                    <ul class="list-unstyled chat-list">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Adam Miller</h5>
                                            </a>
                                        </li>

                                        <li>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Alfonso Fisher</h5>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div class="mt-4">
                                    <div class="px-3 contact-list">B</div>

                                    <ul class="list-unstyled chat-list">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Bonnie Harney</h5>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div class="mt-4">
                                    <div class="px-3 contact-list">C</div>

                                    <ul class="list-unstyled chat-list">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Charles Brown</h5>
                                            </a>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Carmella Jones</h5>
                                            </a>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Carrie Williams</h5>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div class="mt-4">
                                    <div class="px-3 contact-list">D</div>

                                    <ul class="list-unstyled chat-list">
                                        <li>
                                            <a href="javascript:void(0)">
                                                <h5 class="font-size-14 mb-0">Dolores Minter</h5>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ngx-simplebar>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="transactions"></div>
        </div>

    </div>
    <!-- end chat-leftsidebar -->

    <div class="w-100 user-chat mt-4 mt-sm-0 ms-lg-1">
        <div class="card">
            <div class="p-3 px-lg-4 border-bottom">
                <div class="row">
                    <div class="col-xl-4 col-6">
                        <div class="d-flex align-items-center">
                            @if(profile){
                            <div class="flex-shrink-0 avatar-sm me-3 d-sm-block d-none">
                                <img :src="{{profile}}" alt="" class="img-fluid d-block rounded-circle">
                            </div>
                            }@else {
                            <div class="avatar-sm align-self-center me-3"><span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                    {{username.charAt(0)}} </span></div>
                            }

                            <div class="flex-grow-1">
                                <h5 class="font-size-14 mb-1 text-truncate"><a href="javascript:void(0)" class="text-body">{{username}}</a></h5>
                                <p class="text-muted text-truncate mb-0">Online</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8 col-6">
                        <ul class="list-inline user-chat-nav text-end mb-0">
                            <li class="list-inline-item">
                                <div class="dropdown" ngbDropdown>
                                    <button class="btn nav-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        <i class="bx bx-search"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2" ngbDropdownMenu>
                                        <form class="px-2">
                                            <div>
                                                <input type="text" class="form-control border bg-light-subtle" placeholder="Search...">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </li>

                            <li class="list-inline-item">
                                <div class="dropdown" ngbDropdown>
                                    <button class="btn nav-btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        <i class="bx bx-dots-horizontal-rounded"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="fecharConversa()">
                                            <i class="fas fa-times-circle me-2"></i>
                                            Encerrar Atendimento
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0)" (click)="abrirModalTransferirConversa()">
                                            <i class="fas fa-exchange-alt me-2"></i>
                                            Transferir Atendimento
                                        </a>
                                        <!-- <a class="dropdown-item" href="javascript:void(0)">Delete</a> -->
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <ngx-simplebar class="chat-conversation p-3 px-2" style="overflow: auto;">
                <ul class="list-unstyled mb-0">
                    @if (isLoadingMensagens) {
                        <div class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    } @else if (conversaIdAtual === null && conversaSelecionada) {
                        <!-- Mensagem informativa quando não há conversaId (sem mensagens no banco) -->
                        <div class="text-center py-5">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <i class="mdi mdi-information-outline text-muted" style="font-size: 3rem;"></i>
                                <p class="text-muted mt-3 mb-0" style="font-size: 1rem;">
                                    Sem mensagens em nossa base de dados para este contato
                                </p>
                            </div>
                        </div>
                    } @else if (chatMessagesData.length === 0) {
                        <!-- Mensagem quando não há mensagens mas há conversaId -->
                        <div class="text-center py-5">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                                <i class="mdi mdi-message-outline text-muted" style="font-size: 3rem;"></i>
                                <p class="text-muted mt-3 mb-0" style="font-size: 1rem;">
                                    Nenhuma mensagem ainda
                                </p>
                            </div>
                        </div>
                    } @else {
                        @for (item of getMensagensComSeparadores(); track $index) {
                            @if (item.tipo === 'separador') {
                                <li class="chat-day-title">
                                    <span class="title">{{item.data}}</span>
                                </li>
                            } @else if (item.mensagem) {
                                <li [ngClass]="{'right': item.mensagem.align === 'right' }">
                                    <div class="conversation-list" [ngClass]="{'order-3': item.mensagem.align === 'right' }">
                                        <div class="ctext-wrap">
                                            <div class="ctext-wrap-content">
                                                @if (item.mensagem.align !== 'right') {
                                                    <h5 class="conversation-name"><a href="javascript:void(0)" class="user-name">{{item.mensagem.name}}</a>
                                                        <span class="time">{{item.mensagem.time}}</span>
                                                    </h5>
                                                } @else {
                                                    <h5 class="conversation-name"><a href="javascript:void(0)" class="user-name">{{item.mensagem.name}}</a></h5>
                                                }
                                                <p class="mb-0">
                                                    {{ item.mensagem.message }}
                                                </p>
                                                @if (item.mensagem.align === 'right') {
                                                    <div class="message-footer d-flex justify-content-end align-items-center mt-1">
                                                        <span class="time me-1" style="font-size: 0.6875rem; opacity: 0.8;">{{item.mensagem.time}}</span>
                                                        @if (item.mensagem.ackStatus) {
                                                            <span class="message-status-icon ms-1" 
                                                                  [class.text-muted]="item.mensagem.ackStatus === 'pending' || item.mensagem.ackStatus === 'delivered'"
                                                                  [class.text-primary]="item.mensagem.ackStatus === 'read'">
                                                                @if (item.mensagem.ackStatus === 'pending') {
                                                                    <i class="mdi mdi-check" style="font-size: 0.875rem;"></i>
                                                                }
                                                                @if (item.mensagem.ackStatus === 'delivered') {
                                                                    <i class="mdi mdi-check-all" style="font-size: 0.875rem;"></i>
                                                                }
                                                                @if (item.mensagem.ackStatus === 'read') {
                                                                    <i class="mdi mdi-check-all" style="font-size: 0.875rem;"></i>
                                                                }
                                                            </span>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div class="dropdown align-self-start" ngbDropdown>
                                                <a class="dropdown-toggle" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                                    <i class="mdi mdi-dots-vertical"></i>
                                                </a>
                                                <div class="dropdown-menu" ngbDropdownMenu>
                                                    <a class="dropdown-item" href="javascript:void(0);">Em Breve</a>
                                                    <!-- <a class="dropdown-item" href="javascript:void(0);">Save</a>
                                                    <a class="dropdown-item" href="javascript:void(0);">Forward</a>
                                                    <a class="dropdown-item" href="javascript:void(0);">Delete</a> -->
                                                </div>
                                            </div> 
                                        </div>
                                    </div>
                                </li>
                            }
                        }
                    }
                </ul>
            </ngx-simplebar>
            <div class="p-3 border-top">
                <div class="row">
                    <form (ngSubmit)="messageSave()" [formGroup]="formData" class="row">
                        <div class="p-3 chat-input-section">
                            <div class="row">
                                <div class="col">
                                    <div class="position-relative">
                                        <input 
                                            formControlName="message" 
                                            [ngClass]="{'is-invalid': chatSubmit && form['message'].errors}" 
                                            [disabled]="!podeEnviarMensagem()"
                                            type="text" 
                                            class="form-control chat-input rounded" 
                                            [placeholder]="podeEnviarMensagem() ? 'Enter Message...' : 'Conversa fechada ou janela de 24h expirada'" />
                                        @if(chatSubmit && form['message'].errors){
                                        <div class="invalid-feedback">
                                            @if(form['message'].errors['required']){
                                            <span>This value is required.</span>}
                                        </div>}
                                        @if(!podeEnviarMensagem() && chatSelecionado){
                                        <div class="form-text text-muted">
                                            @if(chatSelecionado.status === 'fechada'){
                                            <span>Esta conversa está fechada.</span>
                                            } @else {
                                            <span>A janela de 24 horas para envio de mensagens expirou.</span>
                                            }
                                        </div>}
                                        @if(chatSelecionado && !pertenceAoUsuarioLogado(chatSelecionado)){
                                        <div class="form-text text-muted mt-1" style="font-size: 0.75rem; opacity: 0.8;">
                                            <i class="mdi mdi-alert-outline me-1" style="font-size: 0.7rem;"></i>
                                            <span>Este atendimento está vinculado para ({{chatSelecionado.nomeAtendente}}) outro atendente.</span>
                                        </div>}
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <button 
                                        type="submit" 
                                        class="btn btn-primary chat-send w-md waves-effect waves-light"
                                        [disabled]="!podeEnviarMensagem()">
                                        <span class="d-none d-sm-inline-block me-2">Enviar</span>
                                        <i class="mdi mdi-send float-end"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- end user chat -->
</div>
<!-- End d-lg-flex  -->
